import { useTranslation } from 'react-i18next';

/*
 * The conditions a plate check can record (migration 0045): sporulation stage,
 * the incubator's actual temperature and the light regime. Used by every form
 * that logs a check -- Plates, Lab Mode, the scan station -- so the three stay
 * the same fields with the same limits. pH and humidity (0006) stay where they
 * were in each form.
 *
 * All optional. The server refuses anything outside these lists or the
 * temperature range, and says which field.
 */
export const SPORULATION_STAGES = ['none', 'initiating', 'partial', 'abundant'];
export const LIGHT_REGIMES = ['dark', 'ambient', '12_12', '16_8', 'continuous'];
export const INCUBATION_RANGE_C = [-20, 80];

export const EMPTY_CONDITIONS = { sporulation_stage: '', incubation_temp_c: '', light_regime: '' };

/** The request fields: blanks become absent, the temperature a number. */
export function conditionsPayload(values = {}) {
  const temp = values.incubation_temp_c;
  return {
    sporulation_stage: values.sporulation_stage || undefined,
    incubation_temp_c: temp === '' || temp == null ? undefined : Number(temp),
    light_regime: values.light_regime || undefined,
  };
}

/** One line for a check in a history list, or '' when it recorded none. */
export function conditionsSummary(check, t) {
  const parts = [];
  if (check.sporulation_stage) parts.push(`${t('plates:conditions.sporulation')}: ${t(`plates:conditions.stage_${check.sporulation_stage}`)}`);
  if (check.incubation_temp_c != null) parts.push(`${check.incubation_temp_c} °C`);
  if (check.light_regime) parts.push(t(`plates:conditions.light_${check.light_regime}`));
  return parts.join(' · ');
}

export default function PlateConditionsFields({ values, onChange, labelStyle, inputStyle }) {
  const { t } = useTranslation('plates');
  const set = (name) => (e) => onChange({ ...values, [name]: e.target.value });
  return (
    <>
      <label style={labelStyle}>
        {t('conditions.sporulation')}
        <select data-testid="condition-sporulation" value={values.sporulation_stage || ''}
          onChange={set('sporulation_stage')} style={inputStyle} title={t('tip.sporulation')}>
          <option value="">{t('conditions.notRecorded')}</option>
          {SPORULATION_STAGES.map((s) => <option key={s} value={s}>{t(`conditions.stage_${s}`)}</option>)}
        </select>
      </label>
      <label style={labelStyle}>
        {t('conditions.incubationTemp')}
        <input data-testid="condition-incubation" type="number" step="0.1"
          min={INCUBATION_RANGE_C[0]} max={INCUBATION_RANGE_C[1]}
          value={values.incubation_temp_c ?? ''} onChange={set('incubation_temp_c')} style={inputStyle} title={t('tip.incubationTemp')} />
      </label>
      <label style={labelStyle}>
        {t('conditions.light')}
        <select data-testid="condition-light" value={values.light_regime || ''}
          onChange={set('light_regime')} style={inputStyle} title={t('tip.light')}>
          <option value="">{t('conditions.notRecorded')}</option>
          {LIGHT_REGIMES.map((l) => <option key={l} value={l}>{t(`conditions.light_${l}`)}</option>)}
        </select>
      </label>
    </>
  );
}
